import { Application, Controller } from 'stimulus'
import '@stimulus/polyfills'

import './component.scss'

const selectedTextClass = 'text__tab--selected'
const unSelectPanelClass = 'panel__tab--un-selected'
const selectedPanelClass = 'panel__tab--selected'

const app = Application.start()
app.register('tab-content-builder', class extends Controller {
  switchElement (e) {
    this.switchText(e)
    this.switchPanel(e)
  }

  switchText (e) {
    const currentSelectedTab = this.selectedTab()
    const selectedTab = e.target

    currentSelectedTab.classList.remove(selectedTextClass)
    selectedTab.classList.add(selectedTextClass)
  }

  switchPanel (e) {
    const currentVisiblePanel = this.selectedPanel()
    const clickedVisiblePanel = this.element.querySelector(`#${e.target.id}_panel`)

    currentVisiblePanel.classList.remove(selectedPanelClass)
    currentVisiblePanel.classList.add(unSelectPanelClass)

    clickedVisiblePanel.classList.remove(unSelectPanelClass)
    clickedVisiblePanel.classList.add(selectedPanelClass)
  }

  selectedPanel () {
    return this.element.querySelector(`.${selectedPanelClass}`)
  }

  selectedTab () {
    return this.element.querySelector(`.${selectedTextClass}`)
  }
})
